/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
var View = require('../../view/modal/Logistics');
var Model = nb.define({
    parent:require('./Dialog'),
    method:{
        init:function () {
            this.set('modalName','complete-logistics');

            //打开时 set状态
            this.onChange('show',function (inEvent,inData) {
                this.set('logisticsState',inData)
            },this)
        },
        setData:function () {
            return {
                cn: {
                    title:'物流信息',
                    tit1:'创建订单',
                    tit2:'开始捡货',
                    tit3:'拣货完成',
                    tit4:'配送中',
                    tit5:'订单完成'

                },
                en: {
                    title:'Logistics Information',
                    tit1:'Create Order',
                    tit2:'Picking',
                    tit3:'Picking complete',
                    tit4:'Deliver',
                    tit5:'Completion'
                }
            }
        }
    }
});
var model = new Model();
var view = new View;
view.setModel(model);
nb.model.onChange(nb.opts.clientReady, function () {
    view.$().appendTo(document.body);
}, this);

module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/Logistics.js
// module id = 170
// module chunks = 3 8